export default {
  'commonParameter.title.addParameter': 'Add Params',
  'commonParameter.title.name': 'Name',
  'commonParameter.title.nameNotNull.message': 'Name cannot be empty!',
  'commonParameter.placeHolder.chooseType': 'Choose Type',
};
